// extracted by mini-css-extract-plugin
module.exports = {"formdiv":"Form_formdiv__3PEo0"};